import React, { useState, useEffect } from 'react'
import Main from '../../../cpn/Main'
import { Form,  Radio, Steps, App, Space } from 'antd'
import Icon from '../../../cpn/Icon'
import UserSelect from '../../user/UserSelect';
import { useTDspjdListQuery, useTDspjdAddMutation, useTDspjdDelMutation } from '../../../store/DianShangYeWuApi';
import ReportNodeEdit from './ReportNodeEdit';
function ReportNodeUpdate() {
    const { message } = App.useApp();
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const {data, isSuccess} = useTDspjdListQuery({dsbzd_spjd_qy_id:qy_id,dsbzd_spjd_user_id:"1"});
    const [list, setList] = useState();
    const [deleteNode] = useTDspjdDelMutation();
    useEffect(() => {
        if(isSuccess && data){
            if(data.Status === 'success' && data.Result){                
                // 先排序数据
                const sortedData = [...data.Result].sort((a, b) => {
                    return a.dsbzd_spjd_xuhao - b.dsbzd_spjd_xuhao;
                });
                
                // 然后 map，判断是否是最后一个元素
                const newArr = sortedData.map((item, index) => {                    
                    //判断当前是否是最后一个节点
                    const isLastNode = sortedData.length - 1 === index;
                    return  {
                        title:<span style={{fontSize:"14px",fontWeight:"bold"}}>{item.dsbzd_spjd_name}</span>,
                        content:<div>
                                     <div style={{fontSize:"14px",marginTop:"10px",marginBottom:"10px"}}>{item.dsbzd_spjd_yh_name} </div>
                                     <Space>
                                        <ReportNodeEdit 
                                            dsbzd_spjd_id={item.dsbzd_spjd_id} 
                                            dsbzd_spjd_xuhao={item.dsbzd_spjd_xuhao}
                                            dsbzd_spjd_name={item.dsbzd_spjd_name}
                                            dsbzd_spjd_yh_name={item.dsbzd_spjd_yh_name}
                                            dsbzd_spjd_yh_id={item.dsbzd_spjd_yh_id}
                                            dsbzd_spjd_content={item.dsbzd_spjd_content}
                                            qy_id={qy_id}
                                            qy_name={qy_name}
                                            yh_id={yh_id}
                                            yh_name={yh_name}
                                        />
                                        {isLastNode && <Icon type='delete' onClick={() => {
                                            deleteNode({
                                                dsbzd_spjd_id: item.dsbzd_spjd_id,
                                            }).then(res => {
                                                if(res.data.Status === 'success'){
                                                    message.success('删除成功')
                                                } else {
                                                    message.error('删除失败'+res.data.Message)
                                                }
                                            })
                                        }} />}
                                     </Space>
                                </div>,
                        key: item.dsbzd_spjd_id,
                    }
                })
                setList(newArr);
            } else {
               setList([]);
            }
        }
    },[data, isSuccess, qy_id, qy_name, yh_id, yh_name, deleteNode, message])
    const [form] = Form.useForm();
    const [info, setInfo] = useState({
        node_type: '',
        node_user_name: '',
        node_content: '',
        node_user_id: '',
    });
    // eslint-disable-next-line no-unused-vars
    const [user, setUser] = useState({dsbzd_spjd_user_id:'',dsbzd_spjd_user_name:''});
    const [addNode] = useTDspjdAddMutation()    
    return (
        <Main selectedKeys={['/ReportNodeUpdate']}>
            <div style={{width: '1800px',backgroundColor: '#fff',padding: '20px',borderRadius: '10px'}}>
                <Form 
                    form={form} 
                    layout='inline' 
                    initialValues={{
                        node_type: '',
                        node_user_name: '',
                        node_content: '',
                        node_user_id: '',
                    }}
                >    
                    <Form.Item  
                        name="node_type" 
                        label="审批类型"
                        wrapperCol={{ span: 14 }}
                        required
                        labelCol={{ span: 10 }} 
                    >
                        <Radio.Group
                            onChange={(e) => {
                                setInfo(prev=>({...prev, node_type: e.target.value}))
                            }}
                            style={{ width: '170px' }}
                        >
                            <Radio value="审批">审批</Radio>
                            <Radio value="抄送">抄送</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <UserSelect 
                        labelCol={{ span: 6}}
                        label="操作员"
                        qy_id={qy_id}
                        onChange={(value) => {
                            console.log(value);
                            setInfo(prev=>({...prev, node_user_name: value.yh_name, node_user_id: value.yh_id}))
                        }}
                        name="node_user_id"
                        required
                        placeholder={info.node_type === '审批' ? '请选择审批人' : '请选择抄送人'}
                        disabled={info.node_type === ''}
                        wrapperCol={{ span: 14 }}
                        style={{ width: '200px' }}
                    />  
                    <Form.Item wrapperCol={{ span: 14 ,offset: 10}}>
                        <Icon 
                            type='add' 
                            onClick={() => {
                                if(!info.node_type){
                                    message.error('请选择节点类型')
                                    return;
                                }
                                if(!info.node_user_name){
                                    message.error('请选择操作员')
                                    return;
                                }
                                addNode({
                                    'dsbzd_spjd_qy_id': qy_id,
                                    'dsbzd_spjd_qy_name': qy_name,
                                    'dsbzd_spjd_xuhao': list.length + 1,
                                    'dsbzd_spjd_name': info.node_type,
                                    'dsbzd_spjd_yh_id': info.node_user_id,
                                    'dsbzd_spjd_yh_name': info.node_user_name,
                                    'dsbzd_spjd_uid': yh_id,
                                    'dsbzd_spjd_uname': yh_name,
                                    'dsbzd_spjd_content': '',
                                    'dsbzd_spjd_user_id': '1',
                                    'dsbzd_spjd_user_name': '1',
                                }).then(res => {
                                    if(res.data.Status === 'success'){
                                        message.success('添加成功')
                                    } else {
                                        message.error('添加失败'+res.data.Message)
                                    }
                                });
                                form.resetFields(['node_type', 'node_user_id', 'node_content']);
                                setInfo(prev => ({
                                    ...prev,
                                    node_type: '',
                                    node_user_name: '',
                                    node_content: '',
                                    node_user_id: '',
                                }));
                            }} 
                            title='添加审批节点' 
                        />
                    </Form.Item>
                </Form>
                <div style={{ marginTop: '20px',width: '' }}>
                    <Steps items={list} size="small" titlePlacement="vertical" />
                </div>
            </div>
        </Main>
    )
}

export default ReportNodeUpdate